import LayoutContainer from 'components/Common/LayoutContainer'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { FlightCampaignsCard } from './FlightCampaignsCard'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import LoadingAnimation from 'components/Common/Loading/LoadingAnimation'

const CampaignsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};

  ${mediaQueryUp.tablet} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${rem(28)};
  }

  ${mediaQueryUp.desktop} {
    grid-template-columns: repeat(3, 1fr);
  }
`

interface Props {
  campaigns: Array<App.FlightCampaign>
  loading?: boolean;
}

export function FlightCampaigns(props: Props) {
  const { campaigns, loading } = props

  if (loading) {
    return (
      <Group direction="horizontal" verticalAlign="center" horizontalAlign="center">
        <LoadingAnimation />
      </Group>
    )
  }

  return (
    <LayoutContainer>
      <CampaignsContainer>
        {campaigns.map(campaign => (
          <FlightCampaignsCard
            key={campaign.id}
            title={campaign.title}
            endDate={campaign.end_date}
            subTitle={campaign.header}
            logoUrl={campaign.airline_logo}
            heroImageId={campaign.hero_image_public_id}
            id={campaign.id}
            hideTime={campaign.type === 'all'}
            price={campaign.price}
            fareClass={campaign.fare_class}
          />
        ))}
      </CampaignsContainer>
    </LayoutContainer>
  )
}
